import { getHelpUrl } from '../../../../utils';
import { HelpArticleContent } from '../../components/types';

export const checkInVideographer: HelpArticleContent = {
  title: 'How to Check-In',
  subtitle:
    'This step-by-step guide walks you through how to complete your check-in to receive your personalised video from the event you attended.',
  sections: [
    {
      id: 'check-in',
      heading: 'Step 1: Check-in',
      intro:
        'You can check in using your email, or quickly authenticate with Google or LinkedIn.',
      blocks: [
        { type: 'subheading', text: 'Option 1: Using your email' },
        {
          type: 'list',
          items: [
            {
              text: 'Enter your email address and click <b>Check-In</b>',
              image: { name: 'check-in-1-1', alt: 'Enter Email' },
            },
            {
              text: 'Re-enter your email and click <b>Check-In</b> again to confirm it’s correct',
              image: { name: 'check-in-1-2', alt: 'Confirm Email' },
            },
          ],
        },
        { type: 'subheading', text: 'Option 2: Using Google or LinkedIn' },
        {
          type: 'list',
          items: [
            {
              text: 'Click <b>Continue with Google</b> or <b>Continue with LinkedIn</b>',
              image: { name: 'check-in-1-3', alt: 'Third-Party Check-In' },
            },
            { text: 'Follow the on-screen prompts to complete the check-in' },
          ],
        },
      ],
    },

    {
      id: 'upload',
      heading: 'Step 2: Upload your photo',
      intro:
        'Once you’ve checked in, it’s time to upload your photo so we can find your best moments from the event.',
      blocks: [
        {
          type: 'list',
          items: [
            {
              text: 'Click on the <b>Upload</b> area',
              image: { name: 'check-in-2-1', alt: 'Upload Area' },
            },
            {
              text: 'Read through the memo that appears and click <b>Got It! Let’s Upload</b>',
              image: { name: 'check-in-2-2', alt: 'Upload Memo' },
            },
            {
              text: 'Choose your preferred upload method',
              note: 'If one of the options doesn’t work, try the other.',
              image: { name: 'check-in-2-3', alt: 'Upload Selector' },
            },
            {
              text: 'Wait for your photo to finish uploading',
              note: 'Please don’t close the page while your image is uploading.',
              image: { name: 'check-in-2-4', alt: 'Uploading Modal' },
            },
          ],
        },
      ],
    },

    {
      id: 'details',
      heading: 'Step 3: Provide your details',
      intro:
        'Almost done! Just add a few details so we can personalise your experience.',
      blocks: [
        {
          type: 'list',
          items: [
            {
              text: 'Fill in your name',
              note: 'If you authenticated via Google or LinkedIn, your name will already be pre-filled.',
              image: { name: 'check-in-3-1', alt: 'Name Field' },
            },
            {
              text: 'Enter any optional fields such as phone number or Instagram handle, then click <b>Submit</b>',
              note: 'These fields may differ depending on your event.',
              image: { name: 'check-in-3-2', alt: 'Details Form' },
            },
            {
              text: 'Wait for your details to finish updating',
              note: 'Please don’t close the page while your details are being updated.',
              image: { name: 'check-in-3-3', alt: 'Updating modal' },
            },
            { text: 'That’s it – you’re checked in! 🎉' },
          ],
        },
      ],
    },

    {
      id: 'next-steps',
      heading: 'What’s Next?',
      intro:
        'Once you’ve completed your check-in, your part is done – we’ll take it from here!',
      blocks: [
        {
          type: 'text',
          text: 'After the event, the event organiser will upload and process the event footage. Once your personalised video is created, you’ll receive an email with a direct link to watch, download, and share it.',
        },
        {
          type: 'text',
          text: `You can read more about what happens after check-in in the <a href="${getHelpUrl('attendee', 'after-check-in')}">I Checked In. What’s Next?</a> article.`,
        },
      ],
    },
  ],
};
